import { files, generalRef } from "@/fireinit.js";
import Vue from "vue";
import axios from "axios";

export default {
  loadSalesTrackingGeneral: async ({ commit, rootState }) => {
    let statsData = await axios.get(
      `${rootState.axios.API}stats/salesTrackingGeneral`,
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );
    commit("setSalesTrackingGeneral", statsData.data);
  },

  // Supplier Stats
  loadSuppliersStats: async ({ commit, rootState }) => {
    let statsData = await axios.get(
      `${rootState.axios.API}stats/suppliersStats`,
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );
    commit("setSuppliersStats", statsData.data.yearData);
    commit("setSuppliersCombinedStats", statsData.data.combinedData);
    commit("setSuppliersMonthStats", statsData.data.monthData);
  },
  supplierStatsLoadByID: async ({ commit, rootState }, id) => {
    let statsData = await axios.get(
      `${rootState.axios.API}stats/suppliersStats/${id}`,
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );

    commit("setSpecificSupplierStats", statsData.data);
  },
  supplierSalesEnquiryBuyerTypeStatsLoadByID: async (
    { commit, rootState },
    id
  ) => {
    let statsData = await axios.get(
      `${rootState.axios.API}stats/supplierSalesEnquiryBuyerTypeStats/${id}`,
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );

    commit("setSupplierSalesEnquiryBuyerTypeStats", statsData.data);
  },
  supplierLeadsBuyerTypeStatsLoadByID: async ({ commit, rootState }, id) => {
    let statsData = await axios.get(
      `${rootState.axios.API}stats/supplierLeadsBuyerTypeStats/${id}`,
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );

    commit("setSupplierLeadsBuyerTypeStats", statsData.data);
  },
  loadSupplierGoodCauseCC: async ({ commit, rootState }, id) => {
    let statsData = await axios.get(
      `${rootState.axios.API}stats/supplierGoodCauseCC/${id}`,
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );

    commit("setSupplierGoodCauseCCStats", statsData.data);
  },

  // Good Cause Stats
  goodCauseStatsLoadByID: async ({ commit, rootState }, id) => {
    let statsData = await axios.get(
      `${rootState.axios.API}stats/goodCauseStats/${id}`,
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );

    commit("setSpecificSupplierStats", statsData.data);
  },
  loadGoodCauseSupplierCategoryCC: async ({ commit, rootState }, id) => {
    let statsData = await axios.get(
      `${rootState.axios.API}stats/goodCauseSupplierCategoryCC/${id}`,
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );

    commit("setGoodCauseSupplierCategoryCCStats", statsData.data);
  },
  goodCauseSalesEnquiryBuyerTypeStatsLoadByID: async (
    { commit, rootState },
    id
  ) => {
    let statsData = await axios.get(
      `${rootState.axios.API}stats/goodCauseSalesEnquiryBuyerTypeStats/${id}`,
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );
    commit("setGoodCauseSalesEnquiryBuyerTypeStats", statsData.data);
  },
  goodCauseLeadsBuyerTypeStatsLoadByID: async ({ commit, rootState }, id) => {
    let statsData = await axios.get(
      `${rootState.axios.API}stats/goodCauseLeadsBuyerTypeStats/${id}`,
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );

    commit("setGoodCauseLeadsBuyerTypeStats", statsData.data);
  },

  // Impact Buyer Stats
  buyerStatsLoadByID: async ({ commit, rootState }, id) => {
    let statsData = await axios.get(
      `${rootState.axios.API}stats/impactBuyerStats/${id}`,
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );

    commit("setSpecificBuyerStats", statsData.data);
  },

  loadImpactBuyerChosenGoodCause: async ({ commit, rootState }, id) => {
    let statsData = await axios.get(
      `${rootState.axios.API}stats/impactBuyerChosenGoodCause/${id}`,
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );

    commit("setImpactBuyerChosenGoodCause", statsData.data[0]);
  },
};
